import React from 'react'
import styles from './styles.module.css'
import SimpleBlockContent from '../../../SimpleBlockContent'
import { $textPrimary, $textTertiary } from '../../../../styles/colors/semantics'
import CheckmarkIcon from '../../../icons/CheckmarkIcon'
import { $green50, $green60 } from '../../../../styles/colors/primitives'

function TeamVrsFeatures({ title, features }) {
  return (
    <div className={styles.wrapper}>
      <div className={styles.contentWrapper}>
        <div className={styles.titleSection}>
          <SimpleBlockContent blocks={title.text} highlight={title.highlight} highlightSx={`color: ${$textTertiary.dark};`}/>
        </div>
        <div className={styles.boxes}>
          <div className={styles.emptyBox}/>
          <div className={styles.middleBoxWrapper}>
            <div className={styles.featuresWrapper}>
              { features.map((f, i) => (
                <div className={styles.feature} key={'feature-' + i}>
                  <div className={styles.iconWrapper}><CheckmarkIcon color={$green50}/></div>
                  <SimpleBlockContent blocks={f.title.text} highlight={f.title.highlight} highlightSx={`color: ${$textPrimary.dark};`} />
                </div>
              ))}
            </div>
          </div>
          <div className={styles.emptyBox}/>
        </div>
      </div>
    </div>
  )
}

export default TeamVrsFeatures
